__turbopack_context__.v({
  "dots": "OsPr2G_dots",
});
